var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IDCardInfo',{attrs:{"source":_vm.customerData,"list":_vm.IDCardList}}),_vm._v(" "),_c('driversLicenseInfo',{attrs:{"source":_vm.customerData,"list":_vm.personalDriversLicenseList}}),_vm._v(" "),_c('hailingLicenceInfo',{attrs:{"source":_vm.customerData,"list":_vm.personalHailingLicenceList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }